import React,{useEffect} from "react";
import { useLocation } from "react-router-dom";
import Header from "../header/Header";
import {Helmet} from "react-helmet";
import Footer from "../footer/Footer";
import ReactGA from 'react-ga';


const ThankYou = () => {
  const location = useLocation();
  const formData = location.state?.formData || {};

  return (

    <div>
      <Helmet>
   
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-148218411-1"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-148218411-1');
          `}
        </script>

   
        <script>
          {`
            gtag('event', 'conversion', {'send_to': 'AW-755511204/fZDkCL6LpJcBEKTfoOgC'});
          `}
        </script>
        <script>
          {`
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:1994288,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `}
        </script>
      </Helmet>

       <Header />
  
      <div className="thankyou">
      <div className="container">
    
      <h2 className="text-center">Thank you for sharing your requirement</h2>
      <div>
       
        
      </div>
      </div>
      </div>
      <Footer />
    </div>
  );
};

export default ThankYou;
